module.exports = __webpack_public_path__ + "static/media/tasks-solid.f41361d1.svg";